module.exports = __webpack_public_path__ + "img/geod_2.5477ce71.jpg";